// import $ from "jquery";
import BottomBar from "./components/BottomBar";
import Main from "./components/Main";
import React, {useEffect, useState} from "react";
import default_bg_image from "./components/images/bg.jpg";

// function useForceUpdate() {
    // const [updatedCity, setUpdatedCity] = useState('');
    // return () => setUpdatedCity(localStorage.getItem('cityName')); // update the state to force render
// }

function App() {
    
    // const forceUpdate = useForceUpdate();
    const [displayDate, setDisplayDate] = useState(localStorage.getItem('setDisplayDate') || true);
    const [weatherQuery, setWeatherQuery] = useState('');
    const [suggestionsTop, setSuggestionsTop] = useState([])
    const [displayShortcut, setDisplayShortcut] = useState(false)
    const [displaySetting, setDisplaySetting] = useState(false)
    const [mainSuggestions, setMainSuggestions] = useState([])
    const [display, setDisplay] = useState(false)
    // let city = localStorage.getItem('cityName')
    // const [cityName, setCityName] = useState(city)
    // let state = localStorage.getItem('stateName')
    // const [stateName, setStateName] = useState(state)
    const [loading, setLoading] = useState(true)
    const [customImage, setCustomImage] = useState(localStorage.getItem('online_tools_custom_bg_image__') || default_bg_image)
    const [showImage, setShowImage] = useState(localStorage.getItem('show_image') || false)


    const closeModal = () => {
        let img = document.getElementById("add_shortcut_img");
        img.classList.remove("imgrotate");
        setDisplay(false)
    }
    useEffect(() => {
        window.addEventListener("click", function (event) {
            if (document.getElementById('keep'))
                document.getElementById('keep').remove()
        });
        // setCityName(localStorage.getItem('cityName'))
        // if (cityName == null) {
            // forceUpdate()
        // }
        setLoading(false)
    }, []);

    return (
        !loading ? <div id='background' style={{height: '100vh'}}>
            <BottomBar
                // cityName={cityName}
                // stateName={stateName}
                setCustomImage={setCustomImage}
                showImage={showImage}
                setShowImage={setShowImage}
                displayDate={displayDate}
                setDisplayDate={setDisplayDate}
                weatherQuery={weatherQuery}
                setWeatherQuery={setWeatherQuery}
                suggestionsTop={suggestionsTop}
                setSuggestionsTop={setSuggestionsTop}
                displayShortcut={displayShortcut}
                setDisplayShortcut={setDisplayShortcut}
                displaySetting={displaySetting}
                setDisplaySetting={setDisplaySetting}
                setMainSuggestions={setMainSuggestions}
                setDisplay={setDisplay}
                closeModal={closeModal}
            />
            <Main
                showImage={showImage}
                setCustomImage={setCustomImage}
                customImage={customImage}
                setShowImage={setShowImage}
                displayDate={displayDate}
                setDisplayDate={setDisplayDate}
                mainSuggestions={mainSuggestions}
                setMainSuggestions={setMainSuggestions}
                setDisplaySetting={setDisplaySetting}
                setDisplayShortcut={setDisplayShortcut}
                setSuggestionsTop={setSuggestionsTop}
                display={display}
                setDisplay={setDisplay}
                closeModal={closeModal}
            />
        </div> : null
    );
}

export default App;